import { useOutletContext, useParams } from "react-router-dom";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import { Lock, Space } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import { useLayoutActions } from "views/Account/Integrations/hooks/useLayoutActions";
import { useLayoutHeading } from "views/Account/Integrations/hooks/useLayoutHeading";
import { useLayoutMeta } from "views/Account/Integrations/hooks/useLayoutMeta";
import { IntegrationsOutletContext } from "views/Account/Integrations/types";

import { ExternalIntegrationQueryResponse } from "./types";

type NewIntegrationsLayoutProps = {
  children: React.ReactNode;
  actions?: JSX.Element | null;
  data?: ExternalIntegrationQueryResponse;
};

const NewIntegrationsLayout = ({ children, actions, data }: NewIntegrationsLayoutProps) => {
  const { integrationId } = useParams<{ integrationId: string }>();
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: integration.name,
      link: `/integrations/${integration.id}`,
    },
    {
      title: integrationId ?? "",
    },
  ]);

  useLayoutHeading(integrationId ?? "");
  useLayoutActions(actions);
  useLayoutMeta(
    <>
      <MetaInfoListItem
        icon={Space}
        linkText={data?.externalIntegration.spaceDetails.name}
        href={`/spaces/${data?.externalIntegration.spaceDetails.id}`}
      />
      <MetaInfoListItem icon={Lock} tooltip="Authentication type">
        Basic
      </MetaInfoListItem>
    </>
  );

  return <>{children}</>;
};

export default NewIntegrationsLayout;
